import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C06A94E2-9606-484B-BC0D-D0B9A2FBA76F
 * name apple-keyboard-option
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/apple-keyboard-option.svg
 * tags
 */
export const AppleKeyboardOptionIcon = createSvgIcon(<><path d="M3,4H9.11L16.15,18H21V20H14.88L7.84,6H3V4M14,4H21V6H14V4Z" /></>, 'AppleKeyboardOptionIcon');
export default AppleKeyboardOptionIcon